import type { AuthenticationSessionResponse } from "../redux/types/Authentication";
import type { IUserState } from "../redux/types/IUserState";

const hasPermission = (permissions: Set<string>, key: string) =>
    permissions.has(key);

export const hydrateApplicationUser = (
    session: AuthenticationSessionResponse
): IUserState => {
    if (
        !session.authenticated ||
        !session.user ||
        !session.organization ||
        !session.entitlements
    ) {
        return {
            csrf_token: "",
            socket_token: "",
            units: 0,
            userName: "",
            isLicensedForEstimation: false,
        };
    }

    const permissions = new Set(session.permissions);
    return {
        id: session.user.id,
        email: session.user.email,
        company: session.organization.name,
        environment: session.organization.environment,
        organization_id: session.organization.id,
        userName: session.user.username,
        firstName: session.user.firstName,
        lastName: session.user.lastName,
        csrf_token: session.csrfToken ?? "",
        socket_token: session.socketToken ?? "",
        units: session.entitlements.units,
        license: session.entitlements.license,
        license_id: session.entitlements.licenseId ?? undefined,
        licenseDisplayName: session.entitlements.licenseDisplayName,
        licenseEnd: session.entitlements.licenseEnd ?? undefined,
        hasLicense: session.entitlements.licensed,
        hasUserAdmin: hasPermission(permissions, "userAdmin"),
        hasBilling: hasPermission(permissions, "billing"),
        hasMyAccount: hasPermission(permissions, "myAccount"),
        hasApiKeys: hasPermission(permissions, "apiKeys"),
        features: session.entitlements.features,
        seats: session.entitlements.seats,
        hasPendingAwsActivation: session.entitlements.pendingActivation,
        isLicensedForEstimation: session.entitlements.licensedForEstimation,
    };
};
